<template>
  <basic-container>
    <el-switch v-model="toDo" active-text="查看待办任务"></el-switch>

    <avue-crud
      v-show="toDo"
      :option="taskOption"
      :data="task"
      ref="crud"
      v-model="form"
      :page.sync="taskPage"
      :searchShow="true"
      :searchMenuSpan="4"
      :searchBtnText="''"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @row-del="deleteOnlineFollow"
      @row-update="updateOnlineFollow"
      @row-save="saveOnlineFollow"
    >
      <template slot="menuLeft"></template>
      <template slot="waitTaskDetail" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.waitTaskDetail }}
        </div>
      </template>
    </avue-crud>

    <div style="height: 40px"></div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      :searchShow="true"
      :searchMenuSpan="4"
      :searchBtnText="''"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      @row-del="deleteOnlineFollow"
      @row-update="updateOnlineFollow"
      @row-save="saveOnlineFollow"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot="content" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.content }}
        </div>
      </template>
      <template slot="record" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.record }}
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOnlineFollow, saveOrUpdateOnlineFollow, deleteOnlineFollow, getWaitTask } from '@/api/health/manage'
import func from '@/util/func'

export default {
  data() {
    return {
      channel: window.localStorage.getItem('channel'),
      params: {
        channel: window.localStorage.getItem('channel'),
        pcUserId: window.localStorage.getItem('pcUserId')
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: false,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        editBtn: true,
        addBtn: true,
        delBtn: true,
        addBtnText: '新 增 数 据',
        selection: true,
        searchMenuSpan: 4,
        column: [
          {
            label: '随访计划',
            prop: 'plan',
            search: true,
            type: 'select',
            searchSpan: 5,
            dicData: [
              { label: '新用户首次随访', value: 0 },
              { label: '老用户定期随访', value: 1 },
              { label: '健康报警跟踪', value: 2 },
              { label: '风险管理级别', value: 6 },
              { label: '健康提醒管理', value: 3 },
              { label: '健康管理辅助', value: 4 },
              { label: '认知行为治疗', value: 5 }
            ]
          },
          {
            label: '预约客户',
            prop: 'customer',
            search: true,
            searchSpan: 5
          },
          {
            label: '联系方式',
            prop: 'phone',
            search: true,
            searchSpan: 5
          },
          {
            label: '随访内容',
            prop: 'content',
            type: 'textarea'
          },
          {
            label: ' 执行时间',
            prop: 'followDate',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
            // search: true,
          },
          {
            label: '方案反馈',
            prop: 'record',
            type: 'textarea'
          },
          {
            label: '随诊是否完成',
            prop: 'finish',
            search: true,
            type: 'select',
            searchSpan: 5,
            searchLabelWidth: 100,
            dicData: [
              { label: '未完成', value: '未完成' },
              { label: '已完成', value: '已完成' }
            ]
          },
          {
            label: ' 数据达标率跟踪',
            prop: 'follow',
            type: 'number',
            // search: true,
            max: 100,
            formatter: (row, column, value) => {
              return value + '%'
            }
          }
        ]
      },
      taskOption: {
        headerAlign: 'center',
        tip: false,
        border: false,
        index: true,
        indexLabel: '待办任务',
        viewBtn: false,
        editBtn: true,
        addBtn: false,
        delBtn: true,
        selection: false,
        searchMenuSpan: 4,
        column: [
          {
            label: ' 待办时间',
            prop: 'waitDate',
            type: 'date',
            editDisabled: true
          },
          {
            label: '任务触发时间',
            prop: 'createTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            editDisabled: true
          },
          {
            label: '健康管理护士',
            prop: 'healthManager',
            editDisabled: true,
          },
          {
            label: '随访计划',
            prop: 'plan',
            type: 'select',
            searchSpan: 5,
            dicData: [
              { label: '新用户首次随访', value: 0 },
              { label: '老用户定期随访', value: 1 },
              { label: '健康报警跟踪', value: 2 },
              { label: '风险管理级别', value: 6 },
              { label: '健康提醒管理', value: 3 },
              { label: '健康管理辅助', value: 4 },
              { label: '认知行为治疗', value: 5 }
            ]
          },
          {
            label: '预约客户',
            prop: 'customer',
            searchSpan: 5
          },
          {
            label: '联系方式',
            prop: 'phone',
            searchSpan: 5
          },
          {
            label: '待办详情',
            prop: 'waitTaskDetail',
            type: 'textarea'
          },
          // {
          //   label: '健康管理师',
          //   prop: 'healthManager',
          //   editDisabled: true,
          // },
          {
            label: '随诊是否完成',
            prop: 'finish',
            type: 'select',
            searchSpan: 5,
            searchLabelWidth: 100,
            dicData: [
              { label: '未完成', value: '未完成' },
              { label: '已完成', value: '已完成' }
            ]
          },
          // {
          //   label: '',
          //   editDisabled: true
          // },
          {
            label: ' 执行时间',
            prop: 'followDate',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true
          },
          {
            label: '随访内容',
            prop: 'content',
            type: 'textarea',
            hide: true
          },
          {
            label: '方案反馈',
            prop: 'record',
            type: 'textarea',
            hide: true
          }
        ]
      },
      data: [
        {
          plan: 0,
          customer: '郭苗苗',
          phone: '13331336208',
          content: '身体无不适',
          followDate: '2025-11-3',
          record: '无不适',
          finished: 1,
          follow: 20
        }
      ],
      toDo: true,
      task: [],
      taskPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    onLoad(page, params) {
      params.channel = window.localStorage.getItem('channel')
      params.pcUserId = window.localStorage.getItem('pcUserId')
      params.type = 1
      getOnlineFollow(page.currentPage, page.pageSize, params).then(res => {
        this.page.total = res.data.total
        this.data = res.data.onlineFollow
      })

      const param = {
        channel: this.channel,
        pcUserId: window.localStorage.getItem('pcUserId'),
        page: this.taskPage.currentPage,
        pageSize: this.taskPage.pageSize / 2
      }

      console.log(this.channel)

      getWaitTask(param).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377' && res.data.waitTask.length > 0) {
          res.data.waitTask.forEach(item => {
              item.mobile = func.maskPhone(item.mobile);
              // item.name = func.maskName(item.name);
          });
        }
        this.task = res.data.waitTask
        console.log('task', res.data)
      })
    },

    saveOnlineFollow(row, index, done, loading) {
      console.log('save?')
      row.channel = window.localStorage.getItem('channel')
      row.pcUserId = window.localStorage.getItem('pcUserId')
      row.type = 1
      saveOrUpdateOnlineFollow(row)
        .then(res => {
          done()
          this.$refs.crud.closeDialog() // 强制关闭弹窗
          this.onLoad(this.page, this.params)
          this.$message.success('添加成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    updateOnlineFollow(row, index, done, loading) {
      row.channel = window.localStorage.getItem('channel')
      row.pcUserId = window.localStorage.getItem('pcUserId')
      row.type = 1
      if (row.id == null) {
        done()
        this.$message.success('数据未修改!')
        return
      }
      saveOrUpdateOnlineFollow(row)
        .then(() => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('修改成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    deleteOnlineFollow(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return deleteOnlineFollow(row)
        })
        .then(() => {
          this.onLoad(this.page, this.params)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem('channel'),
        pcUserId: window.localStorage.getItem('pcUserId')
      }
      this.onLoad(this.page, this.params)
    },

    searchChange(params, done) {
      console.log('SeachChange?')
      params.channel = window.localStorage.getItem('channel')
      params.pcUserId = window.localStorage.getItem('pcUserId')
      this.params = params
      this.page.currentPage = 1
      this.taskPage.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    }
  }
}
</script>
<style>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
